/**
 * Login return-to (e.g. an emailed « Décisions de retour » deep link survives
 * the login page). The target comes from the URL, so it is attacker-controlled:
 * only a same-site relative path is accepted — a single leading "/", no "//"
 * or "/\" (protocol-relative), no backslash or control character anywhere
 * (browsers turn "\" into "/" and strip tabs/newlines, which can rebuild "//"),
 * no scheme, and never the auth pages themselves (loop).
 */
const AUTH_PAGES = ['/login', '/forgot-password', '/reset-password'];

export function safeReturnTo(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > 2048) return null;
  if (!raw.startsWith('/') || raw.startsWith('//')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f\u007f]/.test(raw)) return null;
  let url: URL;
  try {
    url = new URL(raw, 'https://arivo.invalid');
  } catch {
    return null;
  }
  if (url.origin !== 'https://arivo.invalid') return null;
  const path = url.pathname.replace(/\/+$/, '') || '/';
  if (AUTH_PAGES.includes(path)) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

/** The login URL that brings the user back to `path` (+ search) afterwards. */
export function loginPathFor(path: string, search = ''): string {
  const target = safeReturnTo(`${path}${search}`);
  return target && target !== '/' ? `/login?next=${encodeURIComponent(target)}` : '/login';
}
